import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';

@Directive({
  selector: '[appFeatureEnabled]',
  standalone: true,
})
export class FeatureFlagDirective implements OnInit {
  private el = inject(ElementRef);
  private featureFlagService = inject(FeatureFlagService);

  @Input('appFeatureEnabled') featureEnabled: string = null!;

  ngOnInit(): void {
    this.featureFlagService.isEnabled(this.featureEnabled).subscribe(isEnabled => {
      if (!isEnabled) this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
    });
  }
}
